import apiUrl from '../constants';
import axios from 'axios';


export function createRECManifest(shippingId, token){
    console.log("inside createRECManifest");
    try{
        let inputPayload = {
            ShippingID: shippingId
        }
        return axios({
            method: 'post',
            url: apiUrl.api_url + 'getPostManifestData',
            data: inputPayload,
            headers: {
              'Authorization': 'Bearer ' + token
            }
          });
    }catch(Exception){
        return Exception;
    }
}



// WEBPACK FOOTER //
// ./src/services/createRECManifest.js